import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { RouteWithSubRoutes, NotFound } from '@cordata/buffet';

import DepartmentsIndex from './collection';

const Departments = ({ routes }) => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <DepartmentsIndex />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

export default Departments;
